// styles
import { searchBarStyle, searchBoxStyle, searchLabelStyle } from 'styles';

// libraries
import styled from 'styled-components';
import { TextButton } from 'components';

export const StyledSiteEntryManagement = styled.div`
  .sem-chart {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-top: 16px;
  }
`;

export const StyledSearchBar = styled.div`
  ${searchBarStyle}
  justify-content: flex-start;
  gap: 12px;

  &.double {
    ${searchBarStyle}
  }
`;

export const StyledSearchBox = styled.div`
  ${searchBoxStyle}
`;

export const StyledSearchLabel = styled.div`
  ${searchLabelStyle}
`;

export const StyledHistoryBox = styled.div`
  width: 100%;
  height: 100%;
  background: var(--color-off-white);
  display: flex;
  align-items: center;
  justify-content: center;

  &.white {
    background: var(--color-white) !important;
  }
`;

export const StyledExpandButton = styled(TextButton)`
  width: 30px !important;
  height: 30px !important;
  border-radius: 50% !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: 0 !important;
`;
